import { MatchOddsComponent } from '../pages/odds/match-odds/match-odds.component';
import { Routes } from '@angular/router';

export const oddsRoutes: Routes = [
  {
    path: ':sport/match-odds',
    component: MatchOddsComponent,
  },
];
